import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51106040"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "simpleAgreeLayer" }
const _hoisted_2 = {
  key: 0,
  style: {"margin":"10px auto","display":"flex","flex-direction":"row","justify-content":"center"}
}
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "simpleAgreeHeading" }, "Legal Terms and Privacy", -1))
const _hoisted_5 = { class: "simpleAgreeBody" }
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "simpleAgreeButtonContainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.logo_URL)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.logo_URL,
            style: {"max-width":"66vw","max-height":"72px"}
          }, null, 8, _hoisted_3)
        ]))
      : _createCommentVNode("", true),
    _hoisted_4,
    _createElementVNode("p", _hoisted_5, [
      _createTextVNode(" By clicking \"Agree\", you have read and agree to the "),
      _createElementVNode("a", {
        href: _ctx.termsURL,
        target: "_blank"
      }, "Terms of Use", 8, _hoisted_6),
      _createTextVNode(" and agree to the collection and use of your information by cookies and similar technologies, as set forth in our "),
      _createElementVNode("a", {
        href: _ctx.privacyURL,
        target: "_blank"
      }, "Privacy Policy", 8, _hoisted_7),
      _createTextVNode(". ")
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("a", {
        class: "simpleAgreeButton",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.agreeClick()))
      }, "Agree")
    ])
  ]))
}